import {Button, Col, Form, FormFeedback, Input, Label, Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import Avatar from "react-avatar";
import Badge from "../../components/Badge";
import {useContext, useEffect, useState, useCallback} from "react";
import {useQuery} from "@tanstack/react-query";
import Loader from "../../components/Loader";
import Paginator from "../../components/Paginator";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import AuthContext from "../../context/AuthContext";
import {getCouponStock} from "../../api/api";
import {toast} from "react-toastify";
import {DateTimeOptionsMediumShort} from "../../utils/DateTimeOptions";
import NoneValue from "../../components/NoneValue";
import RecordsNotFound from "../../components/RecordsNotFound";


function CouponStockModal(props) {
    const {refreshToken} = useContext(AuthContext)
    const [page, setPage] = useState(1);
    const [queryKey, setQueryKey] = useState(['coupon-stock-transaction', props.coupon.id, page])
    const [queryEnabled, setQueryEnabled] = useState(false)
    const [stockTransactionID, setStockTransactionID] = useState("");
    const [stockTransactionName, setStockTransactionName] = useState("");
    const [stock, setStock] = useState("");
    const [stockTransactionType, setStockTransactionType] = useState("");
    const [dateCreated, setDateCreated] = useState("");


    useEffect(() => {
        if (props.modal === true){
            setQueryEnabled(true)
            setQueryKey(['coupon-stock-transaction', props.coupon.id, page])
            // refetch()
        }
        else {
            setQueryEnabled(false)
        }
    }, [page, props.modal, props.coupon.id]);

    const { status, data, error, refetch } = useQuery({
        queryKey: queryKey,
        queryFn: () => getCouponStock(page, props.coupon.id, stockTransactionID, stockTransactionName, stock,
            stockTransactionType, dateCreated),
        keepPreviousData : true,
        retry: false,
        enabled: queryEnabled,
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetch)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        })
    })

    const search = (e) =>{
        e?.preventDefault()
        setPage(1)
        setQueryKey( ['coupon-stock-transaction', props.coupon.id, page, stockTransactionName, stock,
            stockTransactionType, dateCreated,])
    }

    const clearSearch = useCallback((e) => {
        if (e) e?.preventDefault();
        setStockTransactionID('');
        setStockTransactionName('');
        setStock('');
        setStockTransactionType('');
        setDateCreated('');
        // setPage(1);
        setQueryKey(['coupon-stock-transaction', props.coupon.id, page]);
    }, [props.coupon.id, page]);

    useEffect(() => {
        if(stockTransactionID === '' && stockTransactionName === '' && stock === '' && stockTransactionType === '' &&
            dateCreated === ''){
            clearSearch()
        }
    }, [stockTransactionID, stockTransactionName, stock, stockTransactionType, dateCreated, clearSearch]);


    return (
        <>
                <Modal className={'modal-xl'} isOpen={props.modal} toggle={props.modalToggle}>

                    <ModalHeader toggle={props.modalToggle} close={
                        <button className="close" onClick={props.modalToggle}>
                            &times;
                    </button>
                    }>Coupon Stock History: {props.coupon.code}</ModalHeader>

                    <div className="card-box">
                        <div className="row">
                            <div className="col-sm-12">

                                <Form onSubmit={search}>
                                    <Row className="form-row align-items-center">
                                        <Col>
                                            <Label
                                                className="visually-hidden"
                                                for="id"
                                            >
                                                Stock Transaction ID
                                            </Label>
                                            <Input
                                                id="stock-transaction-id"
                                                name="stock-transaction-id"
                                                type="text"
                                                className="form-control mb-2"
                                                onChange={(e) =>
                                                    setStockTransactionID(
                                                        e.target.value
                                                    )
                                                }
                                                value={stockTransactionID}
                                                invalid={
                                                    error && error.response.data.id
                                                }
                                            />
                                            <FormFeedback invalid>
                                                {error && error.response.data.id}
                                            </FormFeedback>
                                        </Col>
                                        <Col>
                                            <Label
                                                className="visually-hidden"
                                                for="name"
                                            >
                                                Stock Transaction Name
                                            </Label>
                                            <Input
                                                id="stock-transaction-name"
                                                name="stock-transaction-name"
                                                type="text"
                                                className="form-control mb-2"
                                                onChange={(e) =>
                                                    setStockTransactionName(
                                                        e.target.value
                                                    )
                                                }
                                                value={stockTransactionName}
                                                invalid={
                                                    error && error.response.data.name
                                                }
                                            />
                                            <FormFeedback invalid>
                                                {error && error.response.data.name}
                                            </FormFeedback>
                                        </Col>
                                        <Col>
                                            <Label
                                                className="visually-hidden"
                                                for="stock"
                                            >
                                                Stock
                                            </Label>
                                            <Input
                                                id="stock"
                                                name="stock"
                                                type="text"
                                                className="form-control mb-2"
                                                onChange={(e) =>
                                                    setStock(
                                                        e.target.value
                                                    )
                                                }
                                                value={stock}
                                                invalid={
                                                    error && error.response.data.stock
                                                }
                                            />
                                            <FormFeedback invalid>
                                                {error && error.response.data.stock}
                                            </FormFeedback>
                                        </Col>
                                        <Col>
                                            <Label
                                                className="visually-hidden"
                                                for="transaction-type"
                                            >
                                                Type
                                            </Label>
                                            <Input
                                                type="select"
                                                id="inputState"
                                                className="form-control mb-2"
                                                value={stockTransactionType}
                                                onChange={(e) =>
                                                    setStockTransactionType(
                                                        e.target.value
                                                    )
                                                }
                                            >
                                                <option value="">--</option>
                                                <option value={'CR'}>
                                                    CREDIT
                                                </option>
                                                <option value={'DR'}>
                                                    DEBIT
                                                </option>
                                                <option value={'RESET'}>
                                                    RESET
                                                </option>
                                            </Input>
                                            {/*<FormFeedback invalid>*/}
                                            {/*    {error && error.response.data.description}*/}
                                            {/*</FormFeedback>*/}
                                        </Col>
                                        <Col>
                                            <Label
                                                className="visually-hidden"
                                                for="date-created"
                                            >
                                                Created
                                            </Label>
                                            <Input
                                                id="date-created"
                                                name="date-created"
                                                type="date"
                                                className="form-control mb-2"
                                                onChange={(e) =>
                                                    setDateCreated(
                                                        e.target.value
                                                    )
                                                }
                                                value={dateCreated}
                                                invalid={
                                                    error && error.response.data.created
                                                }
                                            />
                                            <FormFeedback invalid>
                                                {error && error.response.data.created}
                                            </FormFeedback>
                                        </Col>

                                    </Row>
                                    <Row className="form-row align-items-center">
                                        <Col>
                                            <Button type="submit"
                                                    className="btn bx-btn-primary waves-effect waves-light mr-2"
                                                    disabled={!stockTransactionID && !stockTransactionName && !stock
                                                    && !stockTransactionType && !dateCreated}
                                            >
                                                Search
                                            </Button>

                                            <Button type="button"
                                                    onClick={clearSearch}
                                                    className="btn bx-btn-primary waves-effect waves-light"
                                                    disabled={!stockTransactionID && !stockTransactionName && !stock
                                                    && !stockTransactionType && !dateCreated}
                                            >
                                                Clear
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>


                            </div>
                        </div>
                    </div>

                    {status === 'loading' && (
                        <Loader size={'default'}/>
                    )}

                    {/*{status === 'error' && (*/}
                    {/*    <p>Error...</p>*/}
                    {/*)}*/}

                    {status === 'success' | error?.response?.status === 401 && (
                        <ModalBody>
                            <div className="card-box">
                                <h4 className="header-title">{props.coupon.code} - Stock ({props.coupon.stock === null? <NoneValue/>: props.coupon.stock})</h4>
                                <p className="sub-header">
                                    <Avatar size={95} name={props.coupon.code} round/>
                                </p>

                                <div className="table-responsive">
                                    <table className="table mb-0">

                                        <thead className="font-13 bg-light text-muted">
                                        <tr>
                                            <th className="font-weight-medium">Stock Transaction ID</th>
                                            <th className="font-weight-medium">Stock Transaction Name</th>
                                            <th className="font-weight-medium">Stock</th>
                                            <th className="font-weight-medium">Type</th>
                                            <th className="font-weight-medium">Created</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        {data?.count > 0? data?.results?.map(stock => (
                                            <tr key={stock.id}>
                                                <td className="text-muted font-13">{stock.id === null? <NoneValue/>: stock.id}</td>
                                                <td className="text-muted font-13">{stock.name === null? <NoneValue/>: stock.name}</td>
                                                <td className="text-muted font-13">{stock.stock === null? <NoneValue/>: stock.stock}</td>
                                                <td><Badge badge={
                                                    stock.type === "CR"
                                                        ? "badge badge-light-success"
                                                        : "badge badge-light-danger"
                                                } status={stock.type}/></td>
                                                <td className="text-muted font-13">{new Date(stock.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                            </tr>
                                        )): <RecordsNotFound/>}

                                        </tbody>
                                    </table>
                                </div>
                                {status === 'success' && (
                                    <Paginator data={data} page={page} setPage={setPage} last={data?.last_page}/>
                                )}
                            </div>
                        </ModalBody>
                    )}

                </Modal>

        </>


    );
}

export default CouponStockModal;